import { useIntl } from '@/intl'
import { useBreakpoints } from '@/scopes/common/components/utils/breakpoints'
import * as DialogPrimitive from '@/scopes/search/components/QuickSearchBarLegacy/DialogPrimitive'
import { FilterOption } from '@/scopes/search/types'
import {
  DropdownMultiselect,
  FormField,
  FormFieldControl,
  FormFieldLabel,
  Typography,
  useEditableDropdownMultiselect,
} from '@sunwebgroup/ui-components'
import { isEmpty } from 'ramda'
import * as React from 'react'
import { styled } from 'styled-components'

const MobileConfirmButton = styled(DropdownMultiselect.ConfirmButton)`
  ${DropdownMultiselect.ConfirmButton.modNoShadow()}
`

export function ArrivalAirportFilterComponent({
  onValueChange,
  options,
  selectedValues,
  onEditFinish,
  disabled,
}: {
  onValueChange: (newSelectedValues: string[]) => void
  options: FilterOption<string, object>[]
  selectedValues: string[]
  onEditFinish: (selection: string[]) => void
  disabled?: boolean | undefined
}) {
  const intl = useIntl()
  const { isTablet } = useBreakpoints()

  const multiselectDropdownProps = useEditableDropdownMultiselect({
    value: selectedValues,
    onValueChange,
    onEditFinish,
  })

  if (isEmpty(options)) {
    return null
  }

  return (
    <FormField as="div">
      <FormFieldLabel>{intl.formatMessage({ id: 'search_filter_arrival_airport_label' })}</FormFieldLabel>
      <FormFieldControl>
        <DropdownMultiselect.Root
          disabled={disabled}
          placeholder={intl.formatMessage({ id: 'search_filter_arrival_airport_placeholder' })}
          asDialog={!isTablet}
          {...multiselectDropdownProps}
        >
          <DropdownMultiselect.Selection>
            {options.map(({ value, name }) => (
              <DropdownMultiselect.SelectedValue key={value} value={value}>
                {name}
              </DropdownMultiselect.SelectedValue>
            ))}
          </DropdownMultiselect.Selection>
          {isTablet && (
            <DropdownMultiselect.Popover>
              <DropdownMultiselect.Options>
                {options.map(({ value, name, resultsCount }) => (
                  <DropdownMultiselect.CheckboxWithCounterOption key={value} value={value} count={resultsCount}>
                    {name}
                  </DropdownMultiselect.CheckboxWithCounterOption>
                ))}
              </DropdownMultiselect.Options>
              <DropdownMultiselect.ConfirmButton>
                {intl.formatMessage({ id: 'destination_filter_confirm_button' })}
              </DropdownMultiselect.ConfirmButton>
            </DropdownMultiselect.Popover>
          )}
          {!isTablet && (
            <DropdownMultiselect.Dialog>
              <DialogPrimitive.Root>
                <DialogPrimitive.Header>
                  <DialogPrimitive.HeaderTitle>
                    <Typography $variant="body-lg-bold">
                      {intl.formatMessage({ id: 'search_filter_arrival_airport_label' })}
                    </Typography>
                    <DropdownMultiselect.CrossButton />
                  </DialogPrimitive.HeaderTitle>
                </DialogPrimitive.Header>
                <DialogPrimitive.Body>
                  <DropdownMultiselect.Options>
                    {options.map(({ value, name, resultsCount }) => (
                      <DropdownMultiselect.CheckboxWithCounterOption key={value} value={value} count={resultsCount}>
                        {name}
                      </DropdownMultiselect.CheckboxWithCounterOption>
                    ))}
                  </DropdownMultiselect.Options>
                </DialogPrimitive.Body>
                <DialogPrimitive.Footer>
                  <DropdownMultiselect.Footer>
                    <MobileConfirmButton>
                      {intl.formatMessage({ id: 'destination_filter_confirm_button' })}
                    </MobileConfirmButton>
                  </DropdownMultiselect.Footer>
                </DialogPrimitive.Footer>
              </DialogPrimitive.Root>
            </DropdownMultiselect.Dialog>
          )}
        </DropdownMultiselect.Root>
      </FormFieldControl>
    </FormField>
  )
}
